import { htmlToPlainText } from "./htmlToPlainText";
import {
	describeClient, describeEntryLink, downloadBlob,
	formatDate, formatDateTime, formatRange,
} from "./exportHelpers";

/**
 * Build one Markdown document for a range export: a head section with
 * the overall information, then one section per entry with its
 * metadata and text.
 *
 * options:
 *   client         : Parse Client (focused client)
 *   entryLinks     : EntryLink[] already filtered and sorted
 *   from, to       : Date bounds of the export (may be undefined)
 *   attributeNames : names of the selected filter attributes
 *   exportedBy     : full name of the exporting user
 *   exportedAt     : Date of the export (defaults to now; injectable
 *                    for tests)
 */
export function buildDiaryMarkdown(options) {
	const {
		client, entryLinks, from, to, attributeNames, exportedBy,
	} = options;
	const exportedAt = options.exportedAt || new Date();
	const info = describeClient(client);
	const lines = [];

	lines.push("# Tagebuch — " + info.name);
	lines.push("");
	pushMeta(lines, "Gruppe", info.groupName);
	pushMeta(lines, "Geboren am", info.birthday);
	pushMeta(lines, "Hilfebeginn", info.helpBegin);
	pushMeta(lines, "Zeitraum", formatRange(from, to));
	pushMeta(lines, "Attribute",
		attributeNames && attributeNames.length > 0
			? attributeNames.join(", ") : "Alle");
	pushMeta(lines, "Anzahl Einträge", entryLinks.length);
	pushMeta(lines, "Exportiert", formatDate(exportedAt) +
		(exportedBy ? ", " + exportedBy : ""));

	for (const entryLink of entryLinks) {
		const entry = describeEntryLink(entryLink);
		lines.push("");
		lines.push("---");
		lines.push("");
		lines.push("## " + formatDate(entry.createdAt) + " — " +
			(entry.title || "Tagebucheintrag"));
		lines.push("");
		pushMeta(lines, "Autor", entry.authorName);
		pushMeta(lines, "Erstellt", formatDateTime(entry.createdAt));
		pushMeta(lines, "Eintrag", entry.counter);
		pushMeta(lines, "Typ", entry.typeName);
		pushMeta(lines, "Tags",
			entry.tags.length > 0 ? entry.tags.join(", ") : undefined);
		pushMeta(lines, "Bewertung", entry.rating);
		pushMeta(lines, "Anhänge", entry.attachments);
		if (entry.isPrivate) { lines.push("- **Privat**"); }
		lines.push("");
		lines.push(htmlToPlainText(entry.html, { quotePrefix: "> " }));
	}

	return lines.join("\n") + "\n";
}

function pushMeta(lines, label, value) {
	if (value === undefined || value === null || value === "") { return; }
	lines.push("- **" + label + ":** " + value);
}

/** Trigger a browser download of a text file. */
export function downloadTextFile(filename, text) {
	downloadBlob(filename, new Blob([ text ], {
		type: "text/markdown;charset=utf-8",
	}));
}
